import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LayoutComponent} from './modules/layout/layout.component';
import { AuthGuard } from './auth/services';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./modules/kyso/kyso.module').then(m => m.KySoModule)
  },
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./modules/pages-error/pages-error-routing.module').then(m => m.PagesErrorRoutingModule)
  },
  { path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
